import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@/components/ui';
import { saveFileErrorCode, type SavedFile } from '@/native';

/**
 * App 里下载完的那一条提示（CR-054）：存到了哪、叫什么，外加「打开」「分享」。
 *
 * 客户要的是「手机下载后打印出来」—— 打印从「打开」进去的应用里走（WPS、PDF 阅读器）；
 * 发微信、传电脑还是「分享」。CR-043 时点完下载直接弹分享面板，现在分享退成第二个按钮。
 */
export function SavedFileNotice({ file }: { file: SavedFile }) {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);

  async function run(action: () => Promise<void>) {
    setError(null);
    try {
      await action();
    } catch (err) {
      const code = saveFileErrorCode(err);
      if (code === 'CANCELED') return;
      setError(t(code === 'NO_APP' ? 'export.noAppToOpen' : 'errors.unknown'));
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <Alert tone="success">{t('export.savedToDownloads', { name: file.name })}</Alert>
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => void run(file.open)} data-action="export.open">
          {t('export.open')}
        </Button>
        <Button variant="secondary" onClick={() => void run(file.share)} data-action="export.share">
          {t('export.share')}
        </Button>
      </div>
      {error && <Alert>{error}</Alert>}
    </div>
  );
}
